import { RouteObject } from "react-router-dom";

import { lazy } from "react";
import { Navigate } from "react-router-dom";

const DynamicFormsListDashboard = lazy(
  () => import("../../../../pages/admin/dynamic_form_lists_dashboard"),
);
const DynamicFormDashboard = lazy(
  () => import("../../../../pages/admin/dynamic_form_dashboard"),
);

export const dynamicFormRoutes: RouteObject[] = [
  {
    path: "/admin/dynamic-form",
    children: [
      {
        index: true,
        element: <Navigate to="/admin/dynamic-form/forms-list" replace />,
      },
      { path: "forms-list", element: <DynamicFormsListDashboard /> },
      { path: "form/:form_id?", element: <DynamicFormDashboard /> },
    ],
  },
];

// 49616358889
